<script type="ts">
  import { v4 as uuidv4 } from "uuid";
  import { gameState } from "../store";
  import { getRandomEmoji } from "../utils/randomEmojy";

  let text = "";
  let min = 3;

  const onAddPlayer = () => {
    let name = text.trim();
    if (name.length >= min) {
      const newPlayer: Player = {
        id: uuidv4(),
        name,
        icon: getRandomEmoji(),
        color:
          "#" + (((1 << 24) * Math.random()) | 0).toString(16).padStart(6, "0"),
        roundPoints: [],
        statsPoints: [],
        totalPoints: 0,
      };
      gameState.update((current) => {
        return {
          ...current,
          draft: {
            id: current.draft.id,
            name: current.draft.name,
            date: current.draft.date,
            rounds: current.draft.rounds,
            players: [newPlayer, ...current.draft.players],
          },
        };
      });
      text = "";
    } else if (name.length === 0) {
      // unfocus input field when submited empty to hide mobile keyboard
      const textField = document.getElementById("nameInput");
      textField.blur();
    }
  };
</script>

<form
  on:submit|preventDefault={onAddPlayer}
  class="mt-2 text-center"
  autocomplete="off"
>
  <input
    id="nameInput"
    autofocus
    type="text"
    bind:value={text}
    placeholder="Name"
    class="w-full h-12 max-w-xs text-lg text-center bg-transparent border-none outline-none"
  />
</form>
